var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoSearchResultsRobot = function SvgNoSearchResultsRobot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129,
    height: 108
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-17 -8)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.5,
    cy: 110,
    fill: "#caf5ff",
    rx: 51.5,
    ry: 6
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#110737"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.734 59.995a3.6 3.6 0 0 1 1.214 2.288l1.497 12.19a3.62 3.62 0 0 1-7.187.883l-1.497-12.19a3.6 3.6 0 0 1 .733-2.661l-.49-3.242a5.2 5.2 0 0 1-1.304-.716 5.16 5.16 0 0 1-2.05-4.405 21.75 21.75 0 0 1-9.53-4.102c-9.635-7.261-11.56-20.958-4.3-30.594 7.261-9.635 20.959-11.56 30.594-4.3 9.635 7.262 11.56 20.959 4.3 30.594a21.75 21.75 0 0 1-10.839 7.677 5.15 5.15 0 0 1-1.59 4.827l.449 3.75zm-15.49-16.101c7.346 5.535 17.788 4.068 23.324-3.278 5.535-7.346 4.067-17.788-3.278-23.323s-17.788-4.068-23.323 3.278c-5.536 7.345-4.068 17.787 3.277 23.323"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44 23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.267 63.396 27.656 4.38-2.19 13.828-27.656-4.38zm2.494 3.432-.47 2.964 2.964.469.47-2.963zm-.782 4.939-.47 2.963 2.964.47.47-2.964-2.964-.47zM60.527 69.8l-.47 2.963 2.964.47.47-2.964-2.964-.47zm-.782 4.938-.47 2.963 2.964.47.47-2.964z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.25,
    height: 8.25,
    x: 68.5,
    y: 72.5,
    rx: 4.125
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.25,
    height: 8.25,
    y: 47,
    rx: 4.125
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.02 15.986 2.897.776-3.106 11.591-2.898-.776z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.967 19.078 99.173 40.3l-1.553 5.795-79.206-21.223z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.26 36.95 2.897.777-3.106 11.59-2.898-.776zM46.921 23.454l-7.327-1.963a4.125 4.125 0 1 0 7.327 1.963M29.956 2.084l69.547 18.635-13.459 50.228-69.547-18.635zm48.48 27.225a4.125 4.125 0 1 0-2.135 7.97 4.125 4.125 0 0 0 2.135-7.97m-9.805 15.782c2.61 0 3.694 2.073 3.694 3 .964 0 .605.064.964.011.036-2.442-2.28-4.01-4.658-4.01s-4.306 1.632-4.306 4.01c.91 0 .45-.01 1-.01.092-.993.697-3 3.306-3z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 3,
    x: 46,
    y: 83,
    rx: 1.5
  }))))));
};
export default SvgNoSearchResultsRobot;